import React, { useState, useEffect, useRef } from "react";
import { TfiClose } from "react-icons/tfi";
import { useFetchGroupById, useGroupEdit } from "../../../hooks/useGroup";
import FallbackAvatar from "../../../components/ui/FallbackAvatar/FallbackAvatar";
import popupStyle from "../../../style/PopUp.module.css";
import Style from "../../../style/Pages/PopUp/EditGroupNmOrLogo.module.css";
import Loader from "../../../components/ui/Loader/Loader";
import { FaUserGroup } from "react-icons/fa6";

const EditGroupNmOrLogo = ({ Onclose, groupId, updated }) => {
  const handleCancelEdit = () => {
    Onclose();
    // Cancel edit implementation
  };

  const [previewUrl, setPreviewUrl] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const [tempIconFile, setTempIconFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleGroupIconUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    processImageFile(file);
  };

  const processImageFile = (file) => {
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    setTempIconFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (file.type.startsWith("image/")) {
        processImageFile(file);
      }
    }
  };
  const { editGroup, isLoading } = useGroupEdit(groupId);

  const handleSaveChanges = async () => {
    if (!newGroupName.trim() || isLoading) return;

    const data = {
      group_name: newGroupName,
      group_icon: tempIconFile,
    };
    try {
      await editGroup(data);
      Onclose(); // close popup after success
      updated();
    } catch (error) {}
  };

  const {
    selectedGroup,
    // loading: groupLoading,
    // refresh: refreshGroup,
  } = useFetchGroupById(groupId);

  const { group_name, group_icon } = selectedGroup[0] || {};

  const [newGroupName, setNewGroupName] = useState(group_name || "");

  useEffect(() => {
    if (group_name) {
      setNewGroupName(group_name);
    }
  }, [group_name]);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  return (
    <div className={popupStyle.popupBackground} onClick={handleCancelEdit}>
      <div className={Style.EditGrpNdNmContainer}>
        <div
          className={`${popupStyle.PopupContainer} `}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className={Style.popupHeader}>
            <h2>Edit Group</h2>

            <TfiClose onClick={Onclose} size={20} />
          </div>

          {/* Content */}
          <div className={popupStyle.popupContent}>
            <div className={Style.formContainer}>
              {/* Icon Section */}
              <div className={Style.iconSection}>
                <div
                  className={`${Style.avatarUploadArea} ${
                    isDragging ? Style.dragging : ""
                  }`}
                  onClick={() => fileInputRef.current.click()}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  {previewUrl ? (
                    <img
                      src={previewUrl}
                      alt="Preview"
                      className={Style.avatarPreview}
                    />
                  ) : group_icon ? (
                    <img
                      src={`${apiUrl}${group_icon}`}
                      alt={group_name}
                      className={Style.avatarPreview}
                    />
                  ) : (
                    <FallbackAvatar name={group_name} size={100} />
                  )}

                  <div className={Style.avatarOverlay}>
                    <div className={Style.overlayContent}>
                      <span>Click or drag to upload</span>
                    </div>
                  </div>
                </div>

                <input
                  type="file"
                  ref={fileInputRef}
                  className={Style.fileInput}
                  onChange={handleGroupIconUpload}
                  accept="image/*"
                />

                <div className={Style.iconActions}>
                  <button
                    className={Style.changeIconButton}
                    onClick={() => fileInputRef.current.click()}
                  >
                    Change Icon
                  </button>

                  {previewUrl && (
                    <button
                      className={Style.removeIconButton}
                      onClick={() => {
                        if (previewUrl) URL.revokeObjectURL(previewUrl);
                        setPreviewUrl(null);
                        setTempIconFile(null);
                      }}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>

              {/* Name Section */}
              <div className={Style.nameSection}>
                <label>Group Name</label>
                <div className={Style.inputContainer}>
                  <input
                    type="text"
                    value={newGroupName}
                    onChange={(e) => setNewGroupName(e.target.value)}
                    placeholder="Enter group name"
                    className={Style.nameInput}
                  />
                  <div className={Style.inputIcon}>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg> */}
                    <FaUserGroup />
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className={Style.actionButtons}>
                <button
                  className={Style.cancelButton}
                  onClick={handleCancelEdit}
                >
                  Cancel
                </button>
                <button
                  className={`${Style.saveButton} ${
                    isLoading || !newGroupName.trim() ? Style.disabled : ""
                  }`}
                  onClick={handleSaveChanges}
                  disabled={isLoading || !newGroupName.trim()}
                >
                  {isLoading ? <Loader /> : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditGroupNmOrLogo;
